import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import Card from "../components/Card";
import Button from "../components/Button";
import { saveStore } from "../utils/store";

export default function SettingsTab({ store, setStore }) {
  const [exportJson, setExportJson] = useState("");

  const doExport = () => setExportJson(JSON.stringify(store, null, 2));
  const doImport = () => {
    try {
      const parsed = JSON.parse(exportJson);
      saveStore(parsed);
      setStore(parsed);
      alert("Imported. Your data has been loaded.");
    } catch {
      alert("Import failed — invalid JSON.");
    }
  };
  const clearAll = () => {
    if (confirm("This will remove all saved lines and comments. Continue?")) {
      saveStore({});
      setStore({});
    }
  };

  return (
    <>
      <PageHeader
        title="Settings"
        description="Export, import, or reset your notebook data."
      />
      <Card className="lg">
        <div
          className="grid"
          style={{ gridTemplateColumns: "1fr 1fr", gap: 12 }}
        >
          <section>
            <div className="h2" style={{ marginBottom: 6 }}>
              Export
            </div>
            <div className="sm muted" style={{ marginBottom: 8 }}>
              Copy your data for safekeeping.
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <Button onClick={doExport}>Generate JSON</Button>
            </div>
          </section>
          <section>
            <div className="h2" style={{ marginBottom: 6 }}>
              Import
            </div>
            <div className="sm muted" style={{ marginBottom: 8 }}>
              Paste exported JSON and import.
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <Button variant="secondary" onClick={doImport}>
                Import JSON
              </Button>
              <Button className="ghost" onClick={clearAll}>
                Reset all
              </Button>
            </div>
          </section>
        </div>
        <label className="sm" style={{ marginTop: 12 }}>
          Data JSON
          <textarea
            className="input"
            rows={10}
            value={exportJson}
            onChange={(e) => setExportJson(e.target.value)}
            placeholder="{}"
            aria-label="Data JSON"
          />
        </label>
      </Card>
    </>
  );
}
